export const apiRequest = async (config: any) => { return {}; };
export const getCheckSemanticSearchInitialization = async () => { return "SUCCESS"; };
